(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-upupa-party]');
    var api = window.UPUPA_TILAUS;
    if (!root || !api || root.hasAttribute('data-party-ready')) return;
    root.setAttribute('data-party-ready', '');
    var form = root.querySelector('[data-party-form]');
    var date = root.querySelector('[data-party-date]');
    var quantities = Array.from(root.querySelectorAll('[data-party-qty]'));
    var submit = root.querySelector('[data-party-submit]');
    var error = root.querySelector('[data-party-error]');
    var busy = false;
    var labels = JSON.parse(document.querySelector('[data-party-i18n]').textContent);
    var locale = document.documentElement.lang || 'fi';
    function tr(key, values) {
      var text = labels[key] || '';
      Object.keys(values || {}).forEach(function (name) { text = text.split('{' + name + '}').join(String(values[name])); });
      return text;
    }
    var money = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
    function message(text) { error.textContent = text; error.hidden = !text; }
    function total() {
      return quantities.reduce(function (sum, el) {
        var n = Number(el.value);
        return sum + (Number.isSafeInteger(n) && n > 0 && !el.disabled ? n * Number(el.getAttribute('data-price')) : 0);
      }, 0);
    }
    function refresh() {
      var minimum = api.utcToIso(api.partyWindow().first);
      date.min = minimum;
      root.querySelector('[data-party-date-help]').textContent = tr('date_help_dynamic', { date: api.longLabel(api.partyWindow().first) });
      root.querySelectorAll('[data-celebration-menu]').forEach(function (card) {
        var input = card.querySelector('[data-party-qty]');
        var option = card.querySelector('[data-party-variant]').selectedOptions[0];
        input.disabled = !!(date.value && date.value > '2026-12-31') || !option || option.disabled;
        card.querySelector('[data-season-unavailable]').hidden = !date.value || date.value <= '2026-12-31';
      });
      var sum = total();
      var benefit = sum >= 2000 && root.getAttribute('data-benefit-active') === 'true' && date.value && date.value <= '2026-12-31';
      var saving = benefit ? quantities.reduce(function (amount, el) {
        var n = Number(el.value);
        return amount + (Number.isSafeInteger(n) && n > 0 && !el.disabled ? Math.round(Number(el.getAttribute('data-price')) * n * 0.2) : 0);
      }, 0) : 0;
      root.querySelector('[data-party-total]').textContent = money.format((sum - saving) / 100);
      var benefitLine = root.querySelector('[data-party-benefit]');
      benefitLine.hidden = !saving;
      root.querySelector('[data-party-benefit-amount]').textContent = money.format(saving / 100);
      root.querySelector('[data-party-minimum]').textContent = sum <= 0 ? tr('remaining') : tr('minimum_met');
      submit.disabled = busy || sum <= 0 || !!api.partyDateProblem(date.value);
      Array.from(root.querySelectorAll('[data-party-cake-date]')).forEach(function (input) { input.min = minimum; });
    }
    form.addEventListener('input', function () { message(''); refresh(); });
    form.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.matches('[data-party-variant]')) { message(''); refresh(); return; }
      var card = select.closest('[data-party-card]');
      var option = select.selectedOptions[0];
      var quantity = card.querySelector('[data-party-qty]');
      if (!option || option.disabled) return;
      quantity.setAttribute('data-variant', option.value);
      quantity.setAttribute('data-price', option.getAttribute('data-price'));
      card.querySelector('.upupa-party__price').textContent = option.getAttribute('data-money');
      message('');
      refresh();
    });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy) return;
      refresh();
      if (api.partyDateProblem(date.value)) { message(tr('invalid_date')); date.focus(); return; }
      if (total() <= 0) { message(tr('remaining')); return; }
      if (quantities.some(function (el) { return !el.disabled && (!Number.isSafeInteger(Number(el.value)) || Number(el.value) < 0); })) { message(tr('invalid_quantity')); return; }
      var items = quantities.filter(function (el) { return !el.disabled && Number(el.value) > 0; }).map(function (el) {
        var properties = { _upupa_order: 'juhla', _pvm: date.value };
        properties[tr('date_label')] = api.propLabel(api.isoToUtc(date.value));
        properties[tr('order_type_label')] = tr('order_type');
        return { id: Number(el.getAttribute('data-variant')), quantity: Number(el.value), properties: properties };
      });
      busy = true;
      submit.textContent = tr('adding');
      refresh();
      var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        var response = await fetch(route + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!response.ok) throw new Error('add failed');
        await api.syncPikkujouluBenefit();
        window.location.href = route + 'cart';
      } catch (e) {
        message(tr('error'));
        submit.textContent = tr('add');
        busy = true;
        root.querySelector('[data-party-review-cart]').hidden = false;
        refresh();
      }
    });
    var search = root.querySelector('[data-party-search]');
    var categoryPanels = Array.from(root.querySelectorAll('[data-party-category]'));
    var tabBar = root.querySelector('[data-party-tabs]');
    var categoryTabs = [];
    var activeCategory = 0;
    categoryPanels.forEach(function (panel, index) {
      var heading = panel.querySelector('h2');
      var panelId = date.id + '-category-' + index;
      var tabId = panelId + '-tab';
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'upupa-party__tab';
      tab.id = tabId;
      tab.textContent = heading.textContent;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('data-party-tab', String(index));
      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      tabBar.appendChild(tab);
      categoryTabs.push(tab);
    });
    tabBar.hidden = !categoryTabs.length;
    function selectCategory(index, focus) {
      activeCategory = index;
      categoryTabs.forEach(function (tab, i) {
        var selected = i === index && !tab.disabled;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        categoryPanels[i].hidden = !selected;
        if (selected && focus) tab.focus();
      });
    }
    tabBar.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-party-tab]');
      if (tab && !tab.disabled) selectCategory(Number(tab.getAttribute('data-party-tab')), false);
    });
    tabBar.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-party-tab]');
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!tab || keys.indexOf(event.key) < 0) return;
      event.preventDefault();
      var enabled = categoryTabs.filter(function (item) { return !item.disabled; });
      var index = enabled.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = enabled.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + enabled.length) % enabled.length;
      if (enabled[index]) selectCategory(Number(enabled[index].getAttribute('data-party-tab')), true);
    });
    function filterFoods() {
      var term = search.value.trim().toLocaleLowerCase(locale);
      var count = 0;
      Array.from(root.querySelectorAll('[data-party-card]')).forEach(function (card) {
        if (card.closest('upupa-drink-family')) return;
        card.hidden = card.getAttribute('data-search').indexOf(term) < 0;
        if (!card.hidden) count++;
      });
      Array.from(root.querySelectorAll('upupa-drink-family')).forEach(function (family) { count += family.filter(term); });
      categoryPanels.forEach(function (category, index) {
        var hasResults = Array.from(category.querySelectorAll('[data-party-card]')).some(function (card) {
          return !card.hidden && !card.closest('upupa-drink-family[hidden]');
        }) || Array.from(category.querySelectorAll('upupa-drink-family')).some(function (family) { return !family.hidden; });
        categoryTabs[index].disabled = !hasResults;
      });
      if (!categoryTabs[activeCategory] || categoryTabs[activeCategory].disabled) {
        activeCategory = categoryTabs.findIndex(function (tab) { return !tab.disabled; });
      }
      selectCategory(activeCategory, false);
      root.querySelector('[data-party-no-results]').hidden = count > 0;
    }
    search.addEventListener('input', filterFoods);
    filterFoods();
    var requestedFood = new URLSearchParams(window.location.search).get('food');
    var requestedCard = requestedFood && Array.from(root.querySelectorAll('[data-party-card]')).find(function (card) { return card.getAttribute('data-handle') === requestedFood; });
    if (requestedCard) { search.value = requestedCard.getAttribute('data-search'); filterFoods(); }
    var cakeForm = root.querySelector('[data-party-cake] form');
    if (cakeForm) cakeForm.addEventListener('submit', function (event) {
      refresh();
      var cakeDate = cakeForm.querySelector('[data-party-cake-date]');
      var cakeError = root.querySelector('[data-party-cake-error]');
      if (api.partyDateProblem(cakeDate.value)) { event.preventDefault(); cakeError.textContent = tr('cake_invalid_date'); cakeError.hidden = false; cakeDate.focus(); }
    });
    refresh();
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  }
  document.addEventListener('DOMContentLoaded', init);
  if (window.UPUPA_TILAUS) init();
})();




